<template>
    <sweet-modal ref="create-campaign" width="40%" :title="$t('ct-campaign-new-title')" hide-close-button blocking>
      <div class="form-group row">
        <label for="campaign-name" class="col-sm-4 col-form-label">{{ $t('ct-campaign-name') }}</label>
        <div class="col-sm-8">
          <input type="text" id="campaign-name" name="campaign-name" class="form-control" v-model="campaign_name">
        </div>
      </div>

      <button
        slot="button"
        class="btn btn-outline-light" @click.prevent="close">{{ $t('ct-close')}}</button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import {createCampaign} from '../../../../js/services/integrations-internas/socialProof';

export default {
  name: 'SocialProofCampaign',
  components: {
    SweetModal
  },

  data() {
    return {
      campaign_name: ''
    };
  },

  methods: {
    open() {
      this.$refs['create-campaign'].open();
    },

    close() {
      this.$refs['create-campaign'].close();
    },

    save() {
      this.$loading.show();
      createCampaign({campaign_name: this.campaign_name})
        .then(res => {
          this.$snotify.success(this.$t('ct-saved-successfully'));
          this.close();
          this.$emit('updateAllCampaigns');
        })
        .catch(err => {
          console.error('err', err);
        })
        .finally(() => this.$loading.hide());
    }
  }

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SocialProofCampaign.vue